const PublisherAddOrder = () => import('../components/Publisher/AddOrder');
const PublisherEditOrder = () =>
  import('../components/Publisher/AddOrderInfoPage');
const PublisherCreateTask = () => import('../components/Publisher/AddTask');
const PublisherCreatePart = () =>
  import('../components/Publisher/ConfigurePart');
const PublisherCopyFrom = () => import('../components/Publisher/CopyFrom');
const PublisherCopyFromV2 = () => import('../components/Publisher/CopyFromV2');
const PublisherList = () => import('../components/Publisher/List');
const PublisherTasks = () => import('../components/Publisher/Tasks');
const PublisherTaskView = () => import('../modules/Publisher/views/TaskView');
const PublisherWorkInstructions = () =>
  import('../components/Publisher/WorkInstructions');

const publisherRoutes = [
  {
    path: '/view/publisher',
    name: 'publisher-list',
    component: PublisherList,
    meta: { authRequired: true },
  },
  {
    path: '/view/publisher/create',
    name: 'publisher-add-order',
    component: PublisherAddOrder,
    meta: { authRequired: true },
  },
  {
    path: '/view/publisher/:id/edit',
    name: 'publisher-edit-order',
    component: PublisherEditOrder,
    meta: { authRequired: true },
  },
  {
    path: '/view/publisher/:id/copyfrom-v1',
    name: 'publisher-copyfrom',
    component: PublisherCopyFrom,
    meta: { authRequired: true },
  },
  {
    path: '/view/publisher/:id/copyfrom',
    name: 'publisher-copyfrom-v2',
    component: PublisherCopyFromV2,
    meta: { authRequired: true },
  },
  {
    path: '/view/publisher/:id',
    name: 'publisher-tasks',
    component: PublisherTasks,
    meta: { authRequired: true },
  },
  {
    path: '/view/publisher/:id/wi/:packageId?',
    name: 'publisher-work-instructions',
    component: PublisherWorkInstructions,
    meta: { authRequired: true },
  },
  {
    path: '/view/publisher/:id/:taskNumber',
    name: 'publisher-template',
    component: PublisherTaskView,
    meta: { authRequired: true, needsTaskLock: true },
  },
  {
    path: '/view/publisher/:id/create',
    name: 'publisher-create-task',
    component: PublisherCreateTask,
    meta: { authRequired: true },
  },
  {
    path: '/view/publisher/:id/create/part',
    name: 'publisher-create-part',
    component: PublisherCreatePart,
    meta: { authRequired: true },
  },
];

export default publisherRoutes;
